function AdminInstructorsEditController(
  $scope,
  $state,
  $stateParams,
  UsersModel,
  FlashService,
) {}
AdminInstructorsEditController.$inject = [
  "$scope",
  "$state",
  "$stateParams",
  "UsersModel",
  "FlashService",
];
export default AdminInstructorsEditController;
